import React from 'react'
import {
  StyledWrapper,
  StyledTable,
  StyledThead,
  StyledTbody,
  StyledTh,
  StyledTr,
  StyledTd,
} from './styles'

const StatisticsTable = ({ headers, data }) => {
  const getHeaders = () =>
    headers.map((header, index) => <StyledTh key={index}>{header}</StyledTh>)

  const getRow = row =>
    row.map((label, index) => <StyledTd key={index}>{label}</StyledTd>)

  const getRows = () =>
    data.map((row, index) => <StyledTr key={index}>{getRow(row)}</StyledTr>)

  return (
    <StyledWrapper>
      <StyledTable>
        <StyledThead>{getHeaders()}</StyledThead>
        <StyledTbody>{getRows()}</StyledTbody>
      </StyledTable>
    </StyledWrapper>
  )
}

export default StatisticsTable
